
import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { IDatePlace } from 'src/app/models/location.model';
import { DateService } from 'src/app/services/date/date.service';

/**
 * Generated class for the DayCalendarComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'date-place-multi-selector',
  templateUrl: 'date-place-multi-selector.component.html',
  styleUrls: ['./date-place-multi-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: DatePlaceMultiSelectorComponent
    },
    {
        provide: NG_VALIDATORS, 
        useExisting: forwardRef(() => DatePlaceMultiSelectorComponent),
        multi: true,
    },
]
})
export class DatePlaceMultiSelectorComponent implements OnInit {
  form = new FormArray([]);
  _datesPlaces: IDatePlace[];
  defaultDatePlace:IDatePlace = {
    date:new Date().toISOString(),
    geocoding:{},
    fromTimeHour:'08:00',
    toTimeHour:'12:00',
    moment: 'morning',
  }
  local:string = "fr-fr";
  month:string;
  @Input()
  minDate:string;
  @Input()
  maxDate:string;
  @Input()
  opening:number;
  @Input()
  closing:number;
  @Input()
  favoritePlaces:Geolocation[];
  @Input()
  locationTypes:[]
  @Input()
  dayValues:string;
  @Input()
  title:string;
  day:string;  
  year:string;
  dayName: string;
  dateStrLocal:string;
  showPicker = false;
  onChange = (value) => {};
  onTouched = () => {};
  onValidationChange: any = () => {};
  // @Input()
  // value:string | any ;

  @Input()
  value:IDatePlace[] | any[] ;

  touched = false;
  @Input()
  disabled = false;

  minAddDate: string;
  maxAddDate: string;
  addDatesValues:string;

  @Output() valueChanged = new EventEmitter<IDatePlace[]>();

  constructor(public dateService:DateService, public formBuilder: UntypedFormBuilder) {
  }

  ngOnInit(){
  }

  anyValueChanged(){
    this._datesPlaces = this.value = this.form.getRawValue();
    this.onChange(this._datesPlaces);
    this.valueChanged.emit(this._datesPlaces);
  }
  dateChanged(date){
    this.minAddDate = this.form.getRawValue()[this.form.getRawValue().length-1];
    this.anyValueChanged();
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  writeValue(value: IDatePlace[]) {
    if(value){
      this.form.clear();
      for(const datePlace of value){
        this.addFormControl(datePlace);
      }
      this._datesPlaces = value;
    }
  }

  registerOnTouched(onTouched: any) {
      this.onTouched = onTouched;
  }

  markAsTouched() {
      if (!this.touched) {
        this.onTouched();
        this.touched = true;
      }
  }

  validate(control: AbstractControl): ValidationErrors {
    if (this.form.valid) {
      return null;
    }
    console.log(this.form, control);
    let errors : any = {};

    for(const control of this.form.controls){
      errors = this.addControlErrors(errors, control as FormGroup, 'date');
      errors = this.addControlErrors(errors, control as FormGroup, 'fromTimeHour');
      errors = this.addControlErrors(errors, control as FormGroup, 'toTimeHour');
      errors = this.addControlErrors(errors, control as FormGroup, 'geocoding');
    }
    return errors;
  }

  addControlErrors(allErrors: any, control: FormGroup , controlName:string) {

    const errors = {...allErrors};
    console.log(control, controlName);
    const controlErrors = control.controls[controlName].errors;

    if (controlErrors) {
      errors[controlName] = controlErrors;
    }

    return errors;
  }

  registerOnValidatorChange?(fn: () => void): void {
      this.onValidationChange = fn;
  }

  inputValidator(): ValidatorFn  {
      return (control:AbstractControl) : ValidationErrors | null => {
          if(!this.value){
              return {label:{value:false}}
          }
          else {
              return null
          }
      };
  }

  // get datePlacesFormArray() {
  //   return this.form.controls["datePlaces"] as FormArray;
  // }

  addDatePlace(){
    const item = (this._datesPlaces && this._datesPlaces.length>0)?this._datesPlaces[this._datesPlaces.length-1]: {...this.defaultDatePlace};
    let newDate = '';
    if(!this._datesPlaces || this._datesPlaces.length == 0){
      this._datesPlaces = [];
      newDate = this.dateService.addDays(item.date,1);
    }
    else{
      newDate = this.dateService.addDays(this._datesPlaces[this._datesPlaces.length-1]['date'],1)
    }
    item.date = newDate;
    this._datesPlaces.push(item);
    this._datesPlaces = this._datesPlaces.sort(this.dateService.sortByDates);
    this.addFormControl(item);
    this.onChange(this._datesPlaces);
    this.anyValueChanged()
  }

  removeDatePlace(index:number){
    this.form.removeAt(index);
    this.onChange(this._datesPlaces);
    this.anyValueChanged()
  }
 
  addFormControl(item:IDatePlace){
    const itemForm = this.formBuilder.group({
      geocoding: [null, Validators.required],
      name: [null],
      date: [null, Validators.compose([Validators.required])],
      fromTimeHour: [null, Validators.compose([Validators.required])],
      toTimeHour: [null, Validators.compose([Validators.required])],
      moment: [],
    })
    itemForm.patchValue(item);
    this.form.push(itemForm);
    // console.log(this.form.getRawValue());
  }

}
